import { makeStyles } from '@material-ui/core/styles';
import { deepPurple } from '@material-ui/core/colors';

export default makeStyles((theme) => ({
  appBar: {
    borderRadius: 15,
    margin: '30px auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 50px',
    width: '95%',
    background: 'linear-gradient(90.07deg, rgba(255, 255, 255, 0.9) 2.91%, rgba(255, 255, 255, 0.6) 86.38%, rgba(255, 255, 255, 0.3) 86.38%)',
    boxShadow: 'none'
  },
  appBarSmall: {
    borderRadius: 10,
    margin: '30px auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 10px',
    width: '95%',
    background: 'linear-gradient(90.07deg, rgba(255, 255, 255, 0.9) 2.91%, rgba(255, 255, 255, 0.6) 86.38%, rgba(255, 255, 255, 0.3) 86.38%)',
    boxShadow: 'none'
  },
  heading: {
    color: 'rgba(0,183,255, 1)',
    textDecoration: 'none',
  },
  bySustainableGames: {
    opacity: 0.5,
    marginRight: '5px',
  },
  logo: {
    width: 150,
    margin: '0',
  },
  image: {
    marginLeft: '15px',
    marginRight: '25px',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '900px',
  },
  profile: {
    display: 'flex',
    justifyContent: 'space-between',
    // width: '400px',
  },
  userName: {
    display: 'flex',
    alignItems: 'center',
  },
  brandContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
  avatar: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
    marginRight: '15px',
  },
  projectFormBtn: {
    fontSize: '14px',
    marginRight: '20px',
    fontFamily: 'Noto Sans JP, sans-serif',
    textDecoration: 'none',
    color: "#000000",
    "&:hover": {
      // color: "#000000",
      // textDecoration: 'none',
      opacity: 0.7
    }
  },
  projectsBtn: {
    fontSize: '14px',
    marginRight: '20px',
    fontFamily: 'Noto Sans JP, sans-serif',
    textDecoration: 'none',
    color: "#000000",
    boxShadow: 'none',
    "&:hover": {
      boxShadow: 'none',
      opacity: 0.7
    }
  },
  loginBtn: {
    fontSize: '14px',
    marginRight: '20px',
    fontFamily: 'Noto Sans JP, sans-serif',
    textDecoration: 'none',
    color: "#000000",
    "&:hover": {
      boxShadow: 'none',
      opacity: 0.7
    }
  },
  signupBtn: {
    fontSize: '14px',
    marginRight: '20px',
    fontFamily: 'Noto Sans JP, sans-serif',
    textDecoration: 'none',
    color: "#000000",

    "&:hover": {
      boxShadow: 'none',
      opacity: 0.7
    }
  },
  goBackBtn: {
    fontSize: '14px',
    marginRight: '20px',
    fontFamily: 'Noto Sans JP, sans-serif',
    textDecoration: 'none',
    color: "#FFFFFF",
    "&:hover": {
      boxShadow: 'none',
      opacity: 0.7
    }
  },
  betaBtn: {
    fontSize: '14px',
    marginRight: '20px',
    fontFamily: 'Noto Sans JP, sans-serif',
    textDecoration: 'none',
    color: "#FFFFFF",

    "&:hover": {
      boxShadow: 'none',
      opacity: 0.7
    }
  },
  industryDir: {
    background: '#F3923D',
    borderRadius: '15px',
    fontFamily: 'Noto Sans JP, sans-serif',
    weight: '500',
    // minWidth: '160px',
    fontSize: '14px',
    lineHeight: '17px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.02em',
    color: '#FFFFFF',
    boxShadow: 'none',
    "&:hover": {
      background: '#F3923D',
      boxShadow: 'none',
      opacity: 0.7
    }
  },
  startupDir: {
    background: '#86E6EC',
    borderRadius: '15px',
    fontFamily: 'Noto Sans JP, sans-serif',
    weight: '500',
    // minWidth: '160px',
    fontSize: '14px',
    lineHeight: '17px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.02em',
    color: '#FFFFFF',
    boxShadow: 'none',
    "&:hover": {
      background: '#86E6EC',
      boxShadow: 'none',
      opacity: 0.7
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
    border: '2px solid white',
    borderRadius: 6,
    // boxShadow: 'none',
    // border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  center:{
    textAlign: 'center'
  }

}));